import { Flex, HStack, Text } from '@chakra-ui/react';
import Body1 from '@components/typography/Body1';
import { FilterType } from '../../../utils';
import AddLink from '../../AddLink';
import EditLink from '../../EditLink';
import FilterList from '../../FilterList';

const Prescriptions = ({ prescriptions, onFilterChange }) => {
  const hasPrescriptions = !!prescriptions.length;

  const slug = 'prescriptions';

  return (
    <Flex
      mb={5}
      direction="column"
      minWidth={{ lg: '280px' }}
      flexBasis={{ lg: '280px' }}
      flexGrow={2}
      overflow="hidden"
      sx={{
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
      gap={1}
    >
      <HStack>
        <Body1 bold>Prescriptions</Body1>
        {hasPrescriptions && <EditLink slug={slug} />}
      </HStack>
      {hasPrescriptions ? (
        <FilterList type={FilterType.prescriptions} filters={prescriptions} onFilterChange={onFilterChange} />
      ) : (
        <AddLink slug={slug} />
      )}
    </Flex>
  );
};

export default Prescriptions;
